import React from "react";

export function SeverityPill({ severity }) {
  const s = (severity || "low").toLowerCase();
  const cls = { critical: "pill-critical", high: "pill-high", medium: "pill-medium", low: "pill-low" }[s] || "pill-low";
  return <span className={`pill ${cls}`} data-testid={`severity-pill-${s}`}>{s}</span>;
}

export function RiskBadge({ score }) {
  const sev = score >= 80 ? "critical" : score >= 60 ? "high" : score >= 35 ? "medium" : "low";
  const color = { critical: "#dc2626", high: "#ea580c", medium: "#ca8a04", low: "#059669" }[sev];
  return (
    <div className="flex items-center gap-2">
      <div className="font-mono text-xs font-semibold" style={{ color }}>R{score.toFixed(0)}</div>
      <div className="w-16 h-1 bg-slate-200 rounded-full overflow-hidden">
        <div className="h-full" style={{ width: `${Math.min(score, 100)}%`, background: color }} />
      </div>
    </div>
  );
}

export function timeAgo(iso) {
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
